// Mission page donation amount — Pledgeling
(function () {

var IMPACT_URL    = 'https://www.pledgeling.com/widgets/impact'
var POLL_INTERVAL = 30000

var getJSON = function getJSON (url, success) {
  var xhr = new XMLHttpRequest()

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4)
      if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304)
        success(JSON.parse(xhr.responseText))
      else
        console.log(xhr)
  }

  xhr.open('GET', url)
  xhr.setRequestHeader('Accept', 'application/json')
  xhr.setRequestHeader('Content-Type', 'application/json')
  xhr.send()
}

var formatNumber = function formatNumber(value) {
  if (value === null || value === undefined) return '';

  const abs = Math.abs(value);
  if (abs >= 1e12) {
    return (value / 1e12).toFixed(1).replace(/\.0$/, '') + 'T';
  } else if (abs >= 1e9) {
    return (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
  } else if (abs >= 1e6) {
    return (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
  } else if (abs >= 1e3) {
    return (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return String(value);
}

var initImpact = function initImpact (impact) {
  var token = 'PBUYdty7gXwzMv1T'
  getJSON([IMPACT_URL, token].join('/'), function (data) {
    impact.innerHTML = formatNumber(data.amount.toString())
    setTimeout(function () { initImpact(impact) }, POLL_INTERVAL)
  })
}

var init = function init () {
  var impacts = document.querySelectorAll('[data-impact-id]')
  Array.prototype.forEach.call(impacts, initImpact)
}

document.addEventListener('DOMContentLoaded', init)

})();
